<template lang="html">
  <div id="d-page-template-1">

    <!-- <section class="search-section-s1">
      <b-form @submit="onSubmit">
        <b-form-group class="form-group-s1">
          <b-form-input
          v-model="formSearch.keywords"
          type="text"
          placeholder="Buscar..."
          required
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" class="btn-search">
          <i class="far fa-search"></i>
        </b-button>
      </b-form>
    </section> -->

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-sm-6 col-title">
          <h2>Postulaciones</h2>
        </div>
      </div>
    </section>

    <section class="requests-section">
      <div class="box-results">
        <b-card no-body>
          <b-tabs class="tabs-lg" card>

            <!-- Postulaciones -->
            <b-tab title="Postulaciones" active>
              <b-card-text>
                <router-link class="post-template-s5 w-extra"
                  to="#"
                  v-for="(o, oInx) in rows" :key="'oInx-'+oInx">
                  <div class="box-main-content">
                    <div class="box-top">
                      <div class="col col-title">
                        <h5 class="title">{{o.name}}</h5>
                      </div>

                      <div class="col col-posted">
                        <h6 class="date">Publicado {{o.created}}</h6>
                      </div>

                      <div class="col-12 col-location">
                        <h5 class="subtitle">{{o.state}}, {{o.town}}.</h5>
                        <div class="box-bubbles" v-for="(dep, indd) in o.departaments" :key="'dep-'+indd">
                          <span class="bubble">{{dep.name}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="box-info">
                      <h6 class="date">
                        <span class="days">{{o.schedule}}</span>
                      </h6>

                      <div class="descr">
                        <p v-html="o.requirements"></p>
                      </div>
                    </div>
                  </div>

                  <div class="box-extra-content">
                    <div class="box-bubbles">
                      <span class="bubble green">Postulado</span>
                    </div>

                    <div class="box-txt">
                      <span class="date">{{o.aplication_date}}</span>
                    </div>
                  </div>
                </router-link>
              </b-card-text>
            </b-tab>
            <!--  -->

          </b-tabs>
        </b-card>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },
      rows:[],
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
    getRows(){
      axios.get(tools.url("/api/jobsAplications")).then((response)=>{
          this.rows = response.data;
      }).catch(()=>{});
    }
  },
  mounted(){
      this.getRows();
  }
}
</script>
